import { useCrmCallbacks } from '../dashboard/roles/crmDeskData';
import { CallbackTable } from '../dashboard/roles/CrmDeskTables';
import { DeskState } from '../dashboard/roles/ProfileDeskParts';
export function CrmCallbacks() {
  const resource = useCrmCallbacks();
  return <div className="space-y-4 p-6"><h1 className="text-2xl font-semibold">Callbacks</h1><p>Pending callbacks across the team, ordered by due time.</p><button onClick={resource.reload}>Refresh</button><DeskState resource={resource} />{resource.data && <><p>{resource.data.due} due through today</p><CallbackTable rows={resource.data.rows} /></>}</div>;
}
